/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import SourceIcon from '../folders/SourceIcon';
import { getPoster } from '../../actions/MeetingActions';

export default function Poster({ meeting, width = 56, height = 56 }) {
  const { t } = useTranslation();
  const [posterUrl, setPosterUrl] = useState(null);

  useEffect(() => {
    if (!meeting?.id || meeting?.media_type !== 'video') return;
    (async () => {
      const p = await getPoster(meeting.id, {
        width: width,
        height: height,
        fit: 'contain',
      });
      if (p) {
        const url = window.URL.createObjectURL(new Blob([p]));
        setPosterUrl(url);
      }
    })();
  }, [meeting, width, height]);
  return posterUrl ? (
    <img
      css={css`
        width: ${width}px;
        height: ${height}px;
        border-radius: 0.5rem;
        margin-right: 1rem;
      `}
      src={posterUrl}
      width={width}
      height={height}
      alt={t('Thumbnail för transkribering')}
    />
  ) : (
    <SourceIcon source={meeting.source} size="large" />
  );
}
